import { useState } from "react";
import { useValidateCoupon } from "@/hooks/api/useValidateCoupon";
import { useFrameStore } from "@/lib/store/frameStore";
import { usePaymentStore } from "@/lib/store/paymentStore";
import { track, trackError } from "@/lib/analytics/track";
import { useNavigate } from "react-router";
import { toast } from "sonner";
import { ApiError } from "@/api";

export const useCouponValidation = () => {
    const [couponCode, setCouponCode] = useState<string>("");
    const { mutate: validateCoupon, isPending: isValidatingCoupon } = useValidateCoupon();
    const { setPaymentPayload } = usePaymentStore();
    const { frame } = useFrameStore();
    const navigate = useNavigate();
  
    const handleValidateCoupon = () => {
      validateCoupon({ couponCode, childFrameId: frame?.childFrameId || "" }, {
        onSuccess: (data) => {
          setPaymentPayload({
            token: data.token,
            transactionId: data.transactionId,
            childFrameId: frame?.childFrameId || "",
          });
          track("payment_verify_success", { token_present: Boolean(data?.token) });
          navigate("/camera");
        },
        onError: (error) => {
          if (error instanceof ApiError) {
            toast.error(error.body?.error?.message || "Failed to validate coupon");
          }
          track("payment_verify_error", { message: error instanceof Error ? error.message : String(error) });
          trackError({
            type: "payment",
            message: error instanceof Error ? error.message : String(error),
            source: "manual",
            stack: error instanceof Error ? error.stack : undefined,
          });
          // toast.error("Failed to validate coupon");
        },
      });
    };

    return {
        couponCode,
        setCouponCode,
        isValidatingCoupon,
        handleValidateCoupon,
    };
}